import script from "./Repair08Extras.vue?vue&type=script&setup=true&lang=ts"
export * from "./Repair08Extras.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__